export default __webpack_public_path__ + "static/media/location-icon.9ed17c14.svg";